module.exports = __webpack_public_path__ + "static/img/btn_2.0163ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn_2.png
// module id = jvW8
// module chunks = 1